import { useEffect, useState } from 'react';

export enum ScreenOrientationType {
  Portrait = 0,
  Landscape = 1,
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export const useScreenOrientation = (): ScreenOrientationType => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions.width <= windowDimensions.height
    ? ScreenOrientationType.Portrait
    : ScreenOrientationType.Landscape;
};
